import React from 'react'
import PropTypes from 'prop-types'
import { Checkbox } from 'react-icheck'

const CHANNEL_OPTIONS = [
  { label: 'CS alerts channel (Slack)', value: 'cs-alerts' },
  { label: 'Custom Slack webhook', value: 'slack' },
  { label: 'Email', value: 'email' }
]
const DEFAULT_CHANNEL = 'cs-alerts'

// Pulse Intelligence: special-moment CS alert. When on, a comment the widget
// already evaluates that reads as a special moment (a genuine plea, a standout
// story) raises a silent CS alert; the reply still goes out and scoring is
// untouched. The brand describes the moment in the prompt, folded into the
// classify call, so no Detect action is needed on the Twitter path. Persists to
// widget_data.intentBased.specialMoment via redux-form change.
const SpecialMomentCard = ({ specialMoment, change }) => {
  const enabled = specialMoment.enabled === true
  const channel = specialMoment.channel || DEFAULT_CHANNEL
  const update = patch =>
    change('intentBased.specialMoment', { ...specialMoment, ...patch })
  const onToggle = isEnabled =>
    change(
      'intentBased.specialMoment',
      isEnabled ? { ...specialMoment, enabled: true, channel } : {}
    )

  return (
    <div className='form-group darkPanel' data-testid='special-moment'>
      <div className='col-md-12'>
        <div className='portlet light'>
          <div className='portlet-title'>
            <div className='caption'>
              <span className='caption-subject bold font-green-haze uppercase'>
                <i
                  className='glyphicon glyphicon-flag hidden-xs'
                  style={{ marginRight: 8 }}
                />
                Pulse Intelligence: Special Moment
              </span>
            </div>
          </div>
          <div className='portlet-body'>
            <div className='form-group row'>
              <div className='col-sm-12'>
                <p className='help-block'>
                  Alert CS when a comment reads as a special moment (a genuine
                  plea, a standout story). The reply still goes out and scoring
                  is untouched; this is an extra, silent-to-user alert.
                  Detection runs on the comments this widget already evaluates.
                </p>
              </div>
            </div>
            <div className='form-group row'>
              <div className='col-sm-12'>
                <Checkbox
                  id='brt-pulse-moment-enabled'
                  checkboxClass='icheckbox_square'
                  checked={enabled}
                  onChange={e => onToggle(e.target.checked)}
                  label='Enable special-moment CS alert'
                />
              </div>
            </div>
            {enabled && (
              <div>
                <div className='form-group row'>
                  <label className='col-sm-3 col-md-2 control-label'>
                    Prompt
                  </label>
                  <div className='col-sm-9 col-md-10'>
                    <textarea
                      className='form-control'
                      rows={3}
                      aria-label='moment-prompt'
                      placeholder='Describe what counts as a special moment'
                      value={specialMoment.prompt || ''}
                      onChange={e => update({ prompt: e.target.value })}
                    />
                  </div>
                </div>
                <div className='form-group row'>
                  <label className='col-sm-3 col-md-2 control-label'>
                    Alert channel
                  </label>
                  <div className='col-sm-9 col-md-4'>
                    <select
                      className='form-control'
                      aria-label='moment-channel'
                      value={channel}
                      onChange={e => update({ channel: e.target.value })}
                    >
                      {CHANNEL_OPTIONS.map(option => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                {channel === 'slack' && (
                  <div className='form-group row'>
                    <label className='col-sm-3 col-md-2 control-label'>
                      Slack webhook URL
                    </label>
                    <div className='col-sm-9 col-md-6'>
                      <input
                        type='text'
                        className='form-control'
                        aria-label='moment-slack-url'
                        placeholder='https://hooks.slack.com/...'
                        value={specialMoment.slackWebhookUrl || ''}
                        onChange={e => update({ slackWebhookUrl: e.target.value })}
                      />
                    </div>
                  </div>
                )}
                {channel === 'email' && (
                  <div className='form-group row'>
                    <label className='col-sm-3 col-md-2 control-label'>
                      Alert email
                    </label>
                    <div className='col-sm-9 col-md-6'>
                      <input
                        type='text'
                        className='form-control'
                        aria-label='moment-email'
                        placeholder='cs@brand.com'
                        value={specialMoment.email || ''}
                        onChange={e => update({ email: e.target.value })}
                      />
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

SpecialMomentCard.propTypes = {
  specialMoment: PropTypes.object,
  change: PropTypes.func.isRequired
}

SpecialMomentCard.defaultProps = {
  specialMoment: {}
}

export default SpecialMomentCard



// WEBPACK FOOTER //
// ./src/pages/widgets/form/configure-pulse-intelligence/special-moment-card.js